<ng-template #rowActions let-intervention>
  <a
    mat-stroked-button
    [routerLink]="['/interventions', intervention.id]"
    [target]="openInNewTab() ? '_blank' : '_self'"
    [attr.rel]="openInNewTab() ? 'noopener' : null"
    >View</a
  >
</ng-template>

<data-table
  title="Interventions"
  subtitle="This member's interventions, including those of their dependants."
  searchLabel="Search interventions"
  searchPlaceholder="Case number, type or problem"
  loadingMessage="Loading interventions..."
  emptyMessage="No interventions found."
  [rows]="store.items()"
  [columns]="columns()"
  [actionsTemplate]="rowActions"
  [loading]="store.loading()"
  [showRefresh]="true"
  [searchEnabled]="true"
  [searchTerm]="store.filter().search ?? ''"
  [paginationEnabled]="true"
  [pageNumber]="store.pageNumber()"
  [pageSize]="store.pageSize()"
  [totalCount]="store.totalCount()"
  [totalPages]="store.totalPages()"
  (refreshed)="store.load()"
  (searchChanged)="search($event)"
  (pageChanged)="pageChanged($event)">
  <div tableFilters class="mt-1 flex flex-wrap items-start gap-3">
    <div class="w-48">
      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select [value]="store.filter().status ?? ''" (selectionChange)="store.setFilter({ status: $event.value || undefined })">
          <mat-option value="">All</mat-option>
          @for (stage of stages; track stage) {
            <mat-option [value]="stage">{{ stageLabel(stage) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="w-56">
      <mat-form-field appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select
          [value]="store.filter().interventionTypeId ?? ''"
          (selectionChange)="store.setFilter({ interventionTypeId: $event.value || undefined })">
          <mat-option value="">All</mat-option>
          @for (type of interventionStore.interventionTypes(); track type.id) {
            <mat-option [value]="type.id">{{ type.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="w-44">
      <mat-form-field appearance="outline">
        <mat-label>Created from</mat-label>
        <input matInput [matDatepicker]="fromPicker" [value]="createdFrom()" [max]="today" (dateChange)="setCreatedFrom($event.value)" />
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="w-44">
      <mat-form-field appearance="outline">
        <mat-label>Created to</mat-label>
        <input matInput [matDatepicker]="toPicker" [value]="createdTo()" [max]="today" (dateChange)="setCreatedTo($event.value)" />
        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
    </div>

    @if (hasFilter()) {
      <button mat-stroked-button type="button" class="mt-2" (click)="store.clearFilter()">Clear filters</button>
    }
  </div>
</data-table>
